module.exports = __webpack_public_path__ + "static/media/research-2.8dd432ce.svg";